import quantinoFeiernd from '../../assets/avatars/quantino_feiernd.png';
import quantinoFreudig from '../../assets/avatars/quantino_freudig.png';
import quantinoMotivierend from '../../assets/avatars/quantino_motivierend.png';
import quantinoNachdenklich from '../../assets/avatars/quantino_nachdenklich.png';
import quantinoNeutral from '../../assets/avatars/quantino_neutral.png';
import quantinoSchlafend from '../../assets/avatars/quantino_schlafend.png';
import quantinoStolz from '../../assets/avatars/quantino_stolz_daumen_hoch.png';
import quantinoStreng from '../../assets/avatars/quantino_streng.png';
import quantinoTraurig from '../../assets/avatars/quantino_traurig.png';
import quantinoUeberrascht from '../../assets/avatars/quantino_überrascht.png';
import quantinoLiegendWach from '../../assets/avatars/quantino_liegend_1.png';
import quantinoLiegendSchlafend from '../../assets/avatars/quantino_liegend_2.png';

export const quantinoAvatarMap = {
    feiernd: quantinoFeiernd,
    freudig: quantinoFreudig,
    motivierend: quantinoMotivierend,
    nachdenklich: quantinoNachdenklich,
    neutral: quantinoNeutral,
    schlafend: quantinoSchlafend,
    stolz: quantinoStolz,
    streng: quantinoStreng,
    traurig: quantinoTraurig,
    ueberrascht: quantinoUeberrascht,
    liegend_wach: quantinoLiegendWach,
    liegend_schlafend: quantinoLiegendSchlafend,
    default: quantinoNeutral,
};
